// src/config/projects.js
export const projects = [
  {
    id: "nhl-pickem",
    title: "NHL Pick'em Game",
    description:
      "Fantasy NHL web application, with real NHL data. nhl-pickem.vercell.app",
    tech: [
      "Next.js",
      "TypeScript",
      "Tailwind",
      "Prisma",
      "PostgreSQL",
      "Clerk Authentication",
      "NHL API",
    ],
    role: "Full-stack",
    highlight: true,
  },
  {
    id: "virtual-business-card",
    title: "360Mediatalo Virtual Business Card",
    description:
      "Unity based mobile application with a web application using a Vue.js frontend and JavaScript backend.",
    tech: ["Vue.js", "JavaScript", "Unity"],
    role: "Full-stack",
    highlight: true,
  },
  {
    id: "uudenkaupungin-työvene-orientation",
    title: "Uudenkaupungin työvene Orientation",
    description:
      "WordPress work safety orientation for workers of Uudenkaupungin Työvene.",
    tech: ["WordPress"],
    role: "Developer",
    highlight: true,
  },
  {
    id: "portfolio-site",
    title: "This portfolio",
    description:
      "React-based personal portfolio showcasing projects, skills, and background, with interactive UI.",
    tech: ["React", "React Router", "CSS"],
    role: "Frontend",
    highlight: true,
  },
  {
    id: "spa-reservation-backend",
    title: "Space Reservation App Backend",
    description: "Node.js + Express backend for spa services.",
    tech: ["Node.js", "Express", "MySQL"],
    role: "Backend / architecture",
    highlight: true,
  },
  {
    id: "space-reservation-app",
    title: "Space Reservation App",
    description:
      "OOP-driven Python project for reserving spaces, with UML, inheritance, and clean architecture focus.",
    tech: ["Python", "OOP", "UML"],
    role: "Full-stack / architecture",
    highlight: true,
  },
  {
    id: "price-checker-backend",
    title: "Price Checker Backend",
    description:
      "Node.js + Express backend with a RESTful API for tracking and comparing product prices.",
    tech: ["Node.js", "Express", "MongoDB"],
    role: "Backend development",
    highlight: true,
  },
];
